import { Action } from '@ngrx/store';
import { type } from '../../../util';
import { IState } from './i-9-form.reducer';
import { I9StatusesEnum, I9VerificationMethodEnum } from '../../../core/services/i-9-form/interfaces';

export const ActionTypes = {
  FETCH_INFO: type('[I9 From] fetch info'),
  STORE_INFO: type('[I9 From] store info'),
  CHECK_I9_ERROR_PROCESSING: type('[I9 From] check error processing'),
  REINITIATE_I9: type('[I9 From] check reinitiate'),
  FETCH_INFO_AFTER_COMPLETION: type('[I9 Intelligence] fetch info after completion'),
  SAVE_VERIFICATION_METHOD: type('[I9 Intelligence] save verification method'),
  UPDATE_I9_STATUS: type('[I9 Intelligence] update I9 status'),
};

export class FetchI9Info implements Action {
  public type = ActionTypes.FETCH_INFO;

  constructor(public payload?: any) {}
}

export class StoreI9Info implements Action {
  public type = ActionTypes.STORE_INFO;

  constructor(public payload: Partial<IState>) {}
}

export class CheckI9ErrorProcessing implements Action {
  public type = ActionTypes.CHECK_I9_ERROR_PROCESSING;

  constructor(public payload?: any) {}
}

export class ReinitiateI9 implements Action {
  public type = ActionTypes.REINITIATE_I9;

  constructor(public payload?: any) {}
}

export class FetchInfoAfterCompletion implements Action {
  public type = ActionTypes.FETCH_INFO_AFTER_COMPLETION;

  constructor(public payload?: any) {}
}

export class SaveVerificationMethod implements Action {
  public type = ActionTypes.SAVE_VERIFICATION_METHOD;

  constructor(public payload: { method: I9VerificationMethodEnum }) {}
}

export class UpdateI9Status implements Action {
  public type = ActionTypes.UPDATE_I9_STATUS;

  constructor(public payload: { StatusId: I9StatusesEnum }) {}
}

export type TypeAction =
  FetchI9Info |
  StoreI9Info ;
